export enum TypeReport {
  Water = 0,
  Time = 1,
  Trace = 3,
  Driver = 4,
}
